module.exports = __webpack_public_path__ + "img/copy-pay-preview.7fe815b2.png";